import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import ProductDetails from '@/views/ProductDetails.vue'
import ServiceDetails from '@/views/ServiceDetails.vue'
import AllCategories from '@/views/AllCategories.vue'
import CategoryDetails from '@/views/CategoryDetails.vue'
import SearchResult from '@/views/SearchResult.vue'
import SearchResultWithPaging from '@/views/SearchResult.vue'
import ProductsByCategory from '@/views/ProductsByCategory.vue'
import CompanyDetails from '@/views/CompanyDetails.vue'
import ServicesByCategory from '@/views/ServicesByCategory.vue'
import AboutUs from '@/views/AboutUs.vue'
import ContactUs from '@/views/ContactUs.vue'
import FAQ from '@/views/FAQ.vue'
import Help from '@/views/Help.vue'
import LearningCentre from '@/views/LearningCentre.vue'
import Trade from '@/views/Trade.vue'
import Legal from '@/views/Legal.vue'
import CustomerService from '@/views/CustomerService.vue'
import Privacy from '@/views/Privacy'
import Terms from '@/views/Terms'
import Press from '@/views/Press'
import RFQProduct from '@/views/RFQProduct'
import RFQService from '@/views/RFQService'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        { path: "*", component: Home },
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/product/:id',
            name: 'product',
            component: ProductDetails
        },
        {
            path: '/service/:id',
            name: 'service',
            component: ServiceDetails
        },
        {
            path: '/categories',
            name: 'categories',
            component: AllCategories
        },
        {
            path: '/category/:id',
            name: 'category',
            component: CategoryDetails
        },
        // {
        //     path: '/search',
        //     name: 'search',
        //     component: SearchResult
        // },
        {
            path: '/search',
            name: 'search',
            component: SearchResultWithPaging
        },
        {
            path: '/category/:id/products',
            name: 'productsByCategory',
            component: ProductsByCategory
        },
        {
            path: '/company/:id',
            name: 'company',
            component: CompanyDetails
        },
        {
            path: '/company/:id/contactUs/:tab/subject/:subject',
            name: 'companyContactUs',
            component: CompanyDetails
        },
        {
            path: '/category/:id/services',
            name: 'servicesByCategory',
            component: ServicesByCategory
        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: AboutUs
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            component: ContactUs
        },
        {
            path: '/FAQ',
            name: 'FAQ',
            component: FAQ
        },
        {
            path: '/Help',
            name: 'Help',
            component: Help
        },
        {
            path: '/LearningCentre',
            name: 'LearningCentre',
            component: LearningCentre
        },
        {
            path: '/Trade',
            name: 'Trade',
            component: Trade
        },
        {
            path: '/legal',
            name: 'legal',
            component: Legal
        },
        {
            path: '/customerService',
            name: 'customerService',
            component: CustomerService
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms
        },
        {
            path: '/press',
            name: 'press',
            component: Press
        },
        {
            path: '/rfqProduct/:id',
            name: 'rfqProduct',
            component: RFQProduct
        },
        {
            path: '/rfqService/:id',
            name: 'rfqService',
            component: RFQService
        },
    ]
})
